
if(!customElements.get('logo-animator')) {
   class LogoAnimator extends HTMLElement {
    static get DEFAULTS() {
        return {
        mobileMaxWidth: 767,
        scrollDebounceMs: 5,
        desktopScaleVar: '--scale-desktop-value',
        mobileScaleVar: '--scale-mobile-value',
        };
    }

    constructor() {
        super();

        this._headerLogoElement = null;
        this._animateLogoElement = null;
        this._baseScaleValue = 1;
        this._scrollTimeoutId = null;
        this._isInitialized = false;

        this._handleScroll = this._handleScroll.bind(this);
        this._handleResize = this._handleResize.bind(this);
    }

    connectedCallback() {
        this._initialize();
        window.addEventListener('scroll', this._handleScroll, { passive: true });
        window.addEventListener('resize', this._handleResize);
    }

    disconnectedCallback() {
        this._teardown();
        window.removeEventListener('scroll', this._handleScroll);
        window.removeEventListener('resize', this._handleResize);
    }

    /**
     * Optional: allow configuration via attributes
     * e.g. <logo-animator mobile-max-width="640" scroll-debounce-ms="10">
     */
    get _config() {
        const mobileMaxWidthAttr = Number(this.getAttribute('mobile-max-width'));
        const scrollDebounceMsAttr = Number(this.getAttribute('scroll-debounce-ms'));

        return {
        mobileMaxWidth:
            Number.isFinite(mobileMaxWidthAttr)
            ? mobileMaxWidthAttr
            : LogoAnimator.DEFAULTS.mobileMaxWidth,
        scrollDebounceMs:
            Number.isFinite(scrollDebounceMsAttr)
            ? scrollDebounceMsAttr
            : LogoAnimator.DEFAULTS.scrollDebounceMs,
        desktopScaleVar: LogoAnimator.DEFAULTS.desktopScaleVar,
        mobileScaleVar: LogoAnimator.DEFAULTS.mobileScaleVar,
        };
    }

    _initialize() {
        // Look for children inside this element
        this._headerLogoElement = document.querySelector('[js-header-logo]');

        if (!this._headerLogoElement) {
        console.warn(
            'LogoAnimator: Expected children with [js-header-logo]'
        );
        return;
        }

        this._baseScaleValue = this._getLogoScaleValue(this);

        // Set initial scale
        this.style.scale = String(this._baseScaleValue);

        this._isInitialized = true;

        // Run once to set correct initial visibility
        this._updateFromScroll();
    }

    _teardown() {
        if (this._scrollTimeoutId !== null) {
        clearTimeout(this._scrollTimeoutId);
        this._scrollTimeoutId = null;
        }
        this._isInitialized = false;
    }

    _getLogoScaleValue(logoElement) {
        const { mobileMaxWidth, desktopScaleVar, mobileScaleVar } = this._config;
        const isMobileViewport = window
        .matchMedia(`(max-width: ${mobileMaxWidth}px)`)
        .matches;

        const computedStyles = getComputedStyle(logoElement);
        const variableName = isMobileViewport ? mobileScaleVar : desktopScaleVar;
        const rawValue = computedStyles.getPropertyValue(variableName);
        const parsedValue = parseFloat(rawValue);

        // Fallback to 1 if the CSS variable is missing or invalid
        if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
        return 1;
        }

        return parsedValue;
    }

    _handleScroll() {
        if (!this._isInitialized) return;

        const { scrollDebounceMs } = this._config;

        if (this._scrollTimeoutId !== null) {
        clearTimeout(this._scrollTimeoutId);
        }

        this._scrollTimeoutId = setTimeout(() => {
        this._updateFromScroll();
        }, scrollDebounceMs);
    }

    _handleResize() {
        if (!this._isInitialized) return;

        // Recalculate base scale on resize
        this._baseScaleValue = this._getLogoScaleValue(this);
        this.style.scale = String(this._baseScaleValue);

        // Update positions/visibility/scale after resize
        this._updateFromScroll();
    }

    _updateFromScroll() {
        if (!this._headerLogoElement) return;

        const animateLogoRect = this.getBoundingClientRect();
        const animateLogoDocumentTop = animateLogoRect.top + window.scrollY;
        const scrollPosition = window.pageYOffset;
        const baseScaleValue = this._baseScaleValue;

        const isPastLogo = scrollPosition >= animateLogoDocumentTop;

        // Toggle visibility
        this._headerLogoElement.style.opacity = isPastLogo ? '1' : '0';
        this.style.opacity = isPastLogo ? '0' : '1';

        // Scale calculation
        const adjustedPosition =
        animateLogoDocumentTop / baseScaleValue +
        animateLogoDocumentTop -
        scrollPosition;

        const currentScale =
        adjustedPosition / (animateLogoDocumentTop / baseScaleValue);

        this.style.scale = String(currentScale);
        /*if (currentScale <= baseScaleValue && currentScale >= 1) {
        }*/
    }
    }

    // Register the custom element once
    customElements.define('logo-animator', LogoAnimator);

}